module.exports = __webpack_public_path__ + "static/media/trade_button_bg.6a3ac3e3.jpg";